import parsePhoneNumberFromString from "libphonenumber-js";
import * as Yup from "yup";
export const phoneValidation = Yup.object()
  .shape({
    countryCode: Yup.string()
      .required("Country code is required")
      .matches(/^\+\d{1,4}$/, "Invalid country code format"),
    phoneNumber: Yup.string()
      .required("Phone number is required")
      .matches(/^\d+$/, "Phone number must contain only digits")
      .min(4, "Phone number is too short")
      .max(15, "Phone number is too long"),
  })
  .test("is-valid-phone", "Invalid phone number", function (value) {
    if (!value || !value.countryCode || !value.phoneNumber) {
      return true; // Let required handle empty fields
    }

    try {
      const fullPhoneNumber = `${value.countryCode}${value.phoneNumber}`;
      const parsedPhoneNumber = parsePhoneNumberFromString(fullPhoneNumber);
      if (!parsedPhoneNumber) {
        return this.createError({ message: "Invalid phone number format" });
      }
      if (!parsedPhoneNumber.isValid()) {
        return this.createError({
          message: "Invalid phone number for this country",
        });
      }

      const phoneNumber = parsePhoneNumberFromString(fullPhoneNumber);
      if (!phoneNumber || !phoneNumber.isValid()) {
        return this.createError({
          message: "Invalid phone number",
        });
      }

      const nationalNumber = phoneNumber.nationalNumber.toString();

      // Country-specific validation
      switch (phoneNumber.country) {
        case "EG":
          return (
            (nationalNumber.length === 10 &&
              /^1[0125]\d{8}$/.test(nationalNumber)) ||
            this.createError({
              message: "invalid phone number for this country",
            })
          );
        case "SA":
          return (
            (nationalNumber.length === 9 && nationalNumber.startsWith("5")) ||
            this.createError({
              message: "Saudi phone number must be 9 digits starting with 5",
            })
          );

        case "CA":
          return (
            nationalNumber.length === 10 ||
            this.createError({ message: "Phone number must be 10 digits" })
          );

        case "AE":
          return (
            (nationalNumber.length === 9 && nationalNumber.startsWith("5")) ||
            this.createError({
              message: "UAE phone number must be 9 digits starting with 5",
            })
          );

        case "GB":
          return (
            nationalNumber.length === 10 ||
            this.createError({ message: "UK phone number must be 10 digits" })
          );

        case "AU":
          return (
            nationalNumber.length === 9 ||
            this.createError({
              message: "Australian phone number must be 9 digits",
            })
          );

        default:
          return phoneNumber.isValid();
      }
    } catch {
      return this.createError({
        message: "Invalid phone number",
      });
    }
  });
